// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__7HfAl","loader":"Loading_loader__Hc8GO","spin":"Loading_spin__S+J4r"};